exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-wrapper .v-input__slot {\n  margin-bottom: 0 !important;\n}\n.report-wrapper .v-messages {\n  display: none !important;\n}", ""]);

// exports
